export default {
 pageTitle: 'VIE Structure Setup',
 heroTag: 'Enterprise Listing Structure Service',
 heroDesc: 'Professional VIE (Variable Interest Entity) structure setup to pave the way for overseas listing, helping Chinese enterprises access international capital markets',
 emailConsultation: 'Email Consultation',
 learnStructure: 'Learn About VIE Structure',
 whatIsTitle: 'What is VIE Structure?',
 whatIsPara1: 'VIE (Variable Interest Entity) structure is one of the main models for Chinese enterprises going public overseas. Through a series of contractual arrangements, overseas listing entities can control and enjoy the economic benefits of domestic operating entities without direct equity ownership.',
 whatIsPara2: 'This structure is mainly used to solve the problem of foreign capital access restrictions in certain industries in China (such as internet, education, media, etc.), enabling Chinese enterprises in these industries to raise funds and list on overseas capital markets.',
 whatIsPara3: 'Many well-known Chinese companies such as Sina, Baidu, Alibaba, JD.com, and Tencent Music have adopted the VIE structure to list in the United States, Hong Kong and other places.',
 whyNeedTitle: 'Why Need VIE Structure?',
 whyNeedSubtitle: 'The Best Solution for Overseas Listing',
 reason1Title: 'Circumvent Foreign Capital Restrictions',
 reason1Desc: 'Bypass China\'s foreign capital access restrictions in specific industries to achieve overseas financing and listing',
 reason2Title: 'Overseas Financing',
 reason2Desc: 'Raise funds in international capital markets through overseas listing entities to obtain development capital',
 reason3Title: 'International Brand',
 reason3Desc: 'Enhance international reputation and brand value, attract excellent talent',
 reason4Title: 'Capital Exit',
 reason4Desc: 'Provide convenient capital exit channels for founders and investors',
 servicesTitle: 'Our Services',
 servicesSubtitle: 'Comprehensive VIE Structure Setup and Maintenance',
 service1Title: 'Structure Design',
 service1Item1: 'Customize VIE solutions based on enterprise industry characteristics',
 service1Item2: 'Select suitable listing and offshore structure locations',
 service1Item3: 'Design equity structure and incentive plans',
 service1Item4: 'Tax planning and optimization',
 service2Title: 'Overseas Entity Establishment',
 service2Item1: 'Cayman/BVI company registration',
 service2Item2: 'Hong Kong company registration',
 service2Item3: 'Domestic WFOE establishment',
 service2Item4: 'Maintenance management of all-level companies',
 service3Title: 'Agreement Drafting and Execution',
 service3Item1: 'Complete set of VIE control agreements drafting',
 service3Item2: 'Agreement legality and validity review',
 service3Item3: 'Agreement signing and notarization',
 service3Item4: 'Agreement execution supervision and maintenance',
 service4Title: 'Compliance and Risk Management',
 service4Item1: 'Foreign exchange registration and annual inspection',
 service4Item2: 'Tax filing and planning',
 service4Item3: 'Audit and financial reporting',
 service4Item4: 'Continuous compliance monitoring',
 processTitle: 'VIE Structure Setup Process',
 processSubtitle: 'Professional, Standardized and Efficient Service Process',
 step1Title: 'Needs Analysis',
 step1Desc: 'Understand enterprise business model, listing plans and financing needs',
 step2Title: 'Solution Design',
 step2Desc: 'Formulate customized VIE structure plan, including equity structure, tax arrangements, etc.',
 step3Title: 'Overseas Entity Establishment',
 step3Desc: 'Establish listing entities and intermediate companies in Cayman/BVI, Hong Kong, etc.',
 step4Title: 'WFOE Establishment',
 step4Desc: 'Establish wholly foreign-owned enterprise in China',
 step5Title: 'Agreement Signing',
 step5Desc: 'Draft and sign complete set of VIE control agreements',
 step6Title: 'Structure Setup Complete',
 step6Desc: 'VIE structure officially takes effect and begins normal operations',
 step7Title: 'Continuous Services',
 step7Desc: 'Provide follow-up services such as annual maintenance and compliance management',
 ctaTitle: 'Professional VIE Structure Services, Escorting Your Listing Journey',
 ctaDesc: 'Rich experience in VIE structure setup, successfully assisted multiple enterprises in completing overseas listing',
 viewMoreServices: 'View More Services',
}
